import { Shape } from "three";
import { cache } from "../../cache";
export const createSimpleRectangularShape = (left, bottom, width, height) => {
    return cache(() => {
        const shape = new Shape();
        // bottom left
        shape.moveTo(left, bottom);
        //upper left
        shape.lineTo(left, bottom + height);
        //upper right
        shape.lineTo(left + width, bottom + height);
        // bottom right
        shape.lineTo(left + width, bottom);
        // bottom left
        shape.lineTo(left, bottom);
        return shape;
    }, "createSimpleRectangularShape", [left, bottom, width, height]);
};
//# sourceMappingURL=createSimpleRectangularShape.js.map